<template>
  <div>
    <div class="areaH2">
      <h2>{{changeDisplayWord}}</h2>
    </div>
    <div class="container">

      <svg version="1.1" class="org">
        <defs>
          <symbol id="Indicator" viewBox="0 0 400 80">
<!--
<g>
	<path class="st0" :class="{'phase01':isPhase01}" d="M40,38c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V2c0-1.1,0.9-2,2-2h36c1.1,0,2,0.9,2,2V38z"/>
</g>
<g>
	<path class="st0" :class="{'phase02':isPhase02}" d="M360,38c0,1.1-0.9,2-2,2h-36c-1.1,0-2-0.9-2-2V2c0-1.1,0.9-2,2-2h36c1.1,0,2,0.9,2,2V38z"/>
</g>
<g>
	<path class="st0" :class="{'phase03':isPhase03}" d="M200,38c0,1.1-0.9,2-2,2h-36c-1.1,0-2-0.9-2-2V2c0-1.1,0.9-2,2-2h36c1.1,0,2,0.9,2,2V38z"/>
</g>
<g>
  <polygon class="directArrow" points="84.9,7.2 81.7,7.2 94.5,20 81.7,32.8 84.9,32.8 97.7,20 		"/>
  <polygon class="directArrow" points="105.5,7.2 102.3,7.2 115.1,20 102.3,32.8 105.5,32.8 118.3,20 		"/>
</g>
<g>
  <polygon class="directArrow" points="244.9,7.2 241.7,7.2 254.5,20 241.7,32.8 244.9,32.8 257.7,20 		"/>
  <polygon class="directArrow" points="265.5,7.2 262.3,7.2 275.1,20 262.3,32.8 265.5,32.8 278.3,20 		"/>
</g>
-->
<!--
<polygon class="st0 setCenterPhase1" :class="{'phase01':isPhase01, 'anime':isPhase01}" points="49.3,43.8 80,40 49.3,36.2 68.3,11.7 43.8,30.7 40,0 36.2,30.7 11.7,11.7 30.7,36.2 0,40 30.7,43.8 
	11.7,68.3 36.2,49.3 40,80 43.8,49.3 68.3,68.3 "/>
<polygon class="st0 setCenterPhase2" :class="{'phase02':isPhase02, 'anime':isPhase02}"  points="209.3,43.8 240,40 209.3,36.2 228.3,11.7 203.8,30.7 200,0 196.2,30.7 171.7,11.7 190.7,36.2 160,40 
	190.7,43.8 171.7,68.3 196.2,49.3 200,80 203.8,49.3 228.3,68.3 "/>
<polygon class="st0 setCenterPhase3" :class="{'phase03':isPhase03,'anime':isPhase03}" points="369.3,43.8 400,40 369.3,36.2 388.3,11.7 363.8,30.7 360,0 356.2,30.7 331.7,11.7 350.7,36.2 320,40 
	350.7,43.8 331.7,68.3 356.2,49.3 360,80 363.8,49.3 388.3,68.3 "/>
-->
<g>
	<path class="beforePhase" :class="{'phase01':isPhase01, 'afterPhase':isPhase02}" d="M60,58c0,1.1-0.9,2-2,2H22c-1.1,0-2-0.9-2-2V22c0-1.1,0.9-2,2-2h36c1.1,0,2,0.9,2,2V58z"/>
</g>
<g>
	<path class="beforePhase" :class="{'phase02':isPhase02}" d="M220,58c0,1.1-0.9,2-2,2h-36c-1.1,0-2-0.9-2-2V22c0-1.1,0.9-2,2-2h36c1.1,0,2,0.9,2,2V58z"/>
</g>
<g>
	<path class="beforePhase" :class="{'phase03':isPhase03}" d="M380,58c0,1.1-0.9,2-2,2h-36c-1.1,0-2-0.9-2-2V22c0-1.1,0.9-2,2-2h36c1.1,0,2,0.9,2,2V58z"/>
</g>


<g>
  <polygon class="directArrow" points="104.9,27.2 101.7,27.2 114.5,40 101.7,52.8 104.9,52.8 117.7,40 		"/>
  <polygon class="directArrow" points="125.5,27.2 122.3,27.2 135.1,40 122.3,52.8 125.5,52.8 138.3,40 		"/>
</g>
<g>
  <polygon class="directArrow" points="264.9,27.2 261.7,27.2 274.5,40 261.7,52.8 264.9,52.8 277.7,40 		"/>
  <polygon class="directArrow" points="285.5,27.2 282.3,27.2 295.1,40 282.3,52.8 285.5,52.8 298.3,40 		"/>
</g>
          </symbol>
        </defs>
      </svg>
    </div>
  </div>
</template>

<script>
/*親フェーズ の変化はcurrentPhaseをwatchで実現する*/
var isPhase01 = false
var isPhase02 = false
var isPhase03 = false

export default {
  name:'phaseIndicator',
  props: {
    currentPhase: {
      type:String,
      default:'form-input',
    }
  },
  data:function() {
    return {
      isPhase01:true,
      isPhase02,
      isPhase03
    }
  },
  watch: {
    currentPhase:function(aNew,aOld) {
      this.isPhase01 = (aNew==='form-input')?true:false
      this.isPhase02 = (aNew==='form-confirm')?true:false
      this.isPhase03 = (aNew==='form-thanks')?true:false
    }
  },
  computed: {
    changeDisplayWord:function() {
      var aText = ""
      switch(this.currentPhase) {
        case 'form-input':
          aText = "入力"
          break;
        case 'form-confirm':
          aText = "確認"
          break;
        case 'form-thanks':
          aText = "送信"
          break;
        default:
          aText = "エラー"
      }
      return aText;
    }
  },
}
</script>

<style>
</style>